var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannerBox",attrs:{"height":_vm.bannerHeight}},[_c('el-carousel',{attrs:{"height":_vm.bannerHeight}},_vm._l((_vm.bannerArray),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{attrs:{"width":"100%","src":_vm.baseUrl + item.image},on:{"click":function($event){return _vm.linkTo(item.url)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }